/**
 * Enumeration of report types.
 */
export enum ReportTypeModel {
	/**
	 * Pre-edit report. Includes information about rejected records of Rebate Load files.
	 */
	PreEdit = 2,
	/**
	 * Client Submission report. Provides information to compare the current customer submission to the customer submission history.
	 */
	ClientSubmission = 3,
	/**
	 * Pre-Submission report. Shows customers that are active for the selected submission period.
	 */
	PreSubmission = 4,
	/**
	 * NCPDP Issue report. Shows any "bad" (problematic) NCPDP numbers that are actively associated with locations and must be addressed before the next submission.
	 */
	NcpdpIssue = 5,
	/**
	 * Submission report. Shows the list of customers for a particular submission period, their approval status, and any notes added for the submission so the user
	 * can validate the full list and have all notes in one place for review.
	 */
	Submission = 6,
	/**
	 * Customer Updates report. Shows customer locations that were added, terminated, or excluded within a selected date range so operations can notify other
	 * departments.
	 */
	CustomerUpdates = 7
}
